export const save = (key, data, removeguid) => {
  let success = true
  let items
  try {
    const itemhistory = JSON.parse(localStorage.getItem(key)) || {}
    if (removeguid !== '') {
      delete itemhistory[removeguid]
      items = itemhistory
    } else {
      items = Object.assign(itemhistory, data)
    }

    localStorage.setItem(key, JSON.stringify(items))
  } catch (e) {
    success = false
  }
  return success
}

export const get = (key) => {
  const data = JSON.parse(localStorage.getItem(key))
  return data
}
